import React from "react";

import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import AboutUs from "./pages/AboutUs";
import Faqs from "./pages/Faqs";
import Termsofuse from "./pages/Termsofuse";
import ContactUs from "./pages/ContactUs";
import { useEffect } from "react";
import ScrollToTop from "./ScrollToTop";
import { useState } from "react";
import Preloader from "./components/preloader";
import SignUp from "./khojpages/signUp";
import useLocalStorage from "use-local-storage";
import Notification from "./khojpages/NoticationPage/Notification";
import ForgotPassword from "./khojpages/Forget Password/ForgotPassword";
import Login from "./khojpages/Login/Login";
import RestoreAccount from "./khojpages/RestoreAccount/RestoreAccount";
import ManageProfile from "./khojpages/ManageProfile/ManageProfile";
import ViewProfile from "./khojpages/ViewProfile/ViewProfile";
import ApprovalProcess from "./khojpages/ApprovalProcess/ApprovalProcess";
import BulkProfileResume from "./khojpages/BulkProfile-Resume/BulkProfileResume";
import ManageJobs from "./khojpages/ManageJobs/ManageJobs";
import PostJobs from "./khojpages/PostJobs/PostJobs";
import OfferedJobs from "./khojpages/OfferedJobs/OfferedJobs";
import SavedJobs from "./khojpages/SavedJobs/SavedJobs";
import AppliedJobs from "./khojpages/AppliedJobs/AppliedJobs";
import RecommendationJobs from "./khojpages/RecommendationJobs/RecommendationJobs";
import InterviewAndSchedule from "./khojpages/InterviewSchedule/InterviewAndSchedule";
import FollowedCompanies from "./khojpages/FollowedCompanies/FollowedCompanies";
import Settings from "./khojpages/Settings/Settings";
import DeleteProfile from "./khojpages/DeleteProfile/DeleteProfile";
import ChangePassword from "./khojpages/ChangePassword/ChangePassword";
import AlertJobs from "./khojpages/AlertJobs/AlertJobs";
import ManageBatch from "./khojpages/ManageBatch/ManageBatch";

import Searchjobs from "./khojpages/Searchjob/Searchjobs";
import JobApplications from "./khojpages/ManageApplications/ManageApplications";
import EditProfiles from "./khojpages/EditProfile/EditProfile";
import PeopleSearch from "./khojpages/PeopleSearch/PeopleSearch";
import BlockCompanies from "./khojpages/BlockCompany/BlockCompanies";
import InstituteProfile from "./khojpages/InstituteProfile/InstituteProfile";
import ViewJobs from "./khojpages/ViewJobs/ViewJobs";
import ApplicantJobs from "./khojpages/ApplicantJobs/ApplicantJobs";
import AlertCandidates from "./khojpages/AlertCandidates/AlertCandidates";
import ConfirmPassword from "./khojpages/Forget Password/ConfirmPassword";
import PrivateRoute from "./PrivateRouter";
import UserProfile from "./khojpages/PeopleSearch/UserProfile";
import JobDetailsMain from "./khojpages/JobDetails/JobDetailsMain";
import EditJobs from "./khojpages/EditJob/EditJobs";
import CompanyList from "./khojpages/PostJobs/Companies/CompanyList";
import Institute from "./khojpages/Institute/Institute";
import InsititutePage from "./khojpages/TopInstitute/InsititutePage";
import CompanyDetailMain from "./khojpages/PostJobs/Companies/CompanyDetailMain";
import Candidate from "./khojpages/ViewProfile/Candidate";
import UpdateCandidatemain from "./khojpages/UpdateCandidatebyInstitute/UpdateCandidatemain";
import Resume from "./khojpages/Resume/Resume";
import CandidResume from "./khojpages/ViewProfile/CandidResume";
import Home from "./khojpages/Mainhome/Home";
import NotFound from "./khojpages/NotFound";

const App = ({ setIsDark }) => {
  let routes = useRoutes([
    {
      path: "/",
      element: (
        <>
          <PrivateRoute
            element={<Home />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/login",
      element: (
        <>
          <PrivateRoute
            element={<Login />}
            isProtected={false}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/register",
      element: (
        <>
          <PrivateRoute
            element={<SignUp />}
            isProtected={false}
            redirectTo="/Home"
          />
        </>
      ),
    },
    { path: "/RestoreAccount", element: <RestoreAccount /> },
    { path: "/aboutus", element: <AboutUs /> },
    { path: "/faqs", element: <Faqs /> },
    { path: "/Resume", element: <CandidResume /> },
    { path: "/termsofuse", element: <Termsofuse /> },
    { path: "/contactus", element: <ContactUs /> },
    { path: "/companies", element: <CompanyList /> },
    { path: "/Companydetails/:uid", element: <CompanyDetailMain /> },
    { path: "/jobDetails/:JobId", element: <JobDetailsMain /> },
    { path: "/editJob/:JobId", element: <EditJobs /> },
    { path: "/User/:cnddtUID", element: <UserProfile /> },
    { path: "/SetNewPassword", element: <ConfirmPassword /> },
    { path: "/forgotpassword", element: <ForgotPassword /> },
    { path: "/institute", element: <Institute /> },
    { path: "/institutepage", element: <InsititutePage /> },
    {
      path: "/UpdateCandidatebyInstitute/:CandidateId",
      element: <UpdateCandidatemain />,
    },
    { path: "/ManageResume/:CandidateId", element: <Resume /> },
    { path: "/Home", element: <Home /> },
    {
      path: "/notification",
      element: (
        <>
          <PrivateRoute
            element={<Notification />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/savedjobs",
      element: (
        <>
          <PrivateRoute
            element={<SavedJobs />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Appliedjobs",
      element: (
        <>
          <PrivateRoute
            element={<AppliedJobs />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/ManageProfile",
      element: (
        <>
          <PrivateRoute
            element={<ManageProfile />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Profile",
      element: (
        <>
          <PrivateRoute
            element={<ViewProfile />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/AddCandidate",
      element: (
        <>
          <PrivateRoute
            element={<EditProfiles />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Candidate",
      element: (
        <>
          <PrivateRoute
            element={<Candidate />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/CandidateResume/:CandidateId",
      element: (
        <>
          <PrivateRoute
            element={<CandidResume />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/ApprovalProcess",
      element: (
        <>
          <PrivateRoute
            element={<ApprovalProcess />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/InstituteCandidates",
      element: (
        <>
          <PrivateRoute
            element={<BulkProfileResume />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/PostJobs",
      element: (
        <>
          <PrivateRoute
            element={<PostJobs />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/ManageJobs",
      element: (
        <>
          <PrivateRoute
            element={<ManageJobs />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/OfferedJobs",
      element: (
        <>
          <PrivateRoute
            element={<OfferedJobs />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/JobApplications",
      element: (
        <>
          <PrivateRoute
            element={<JobApplications />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/notification",
      element: (
        <>
          <PrivateRoute
            element={<Notification />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/recommendationJobs",
      element: (
        <>
          <PrivateRoute
            element={<RecommendationJobs />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Interviews",
      element: (
        <>
          <PrivateRoute
            element={<InterviewAndSchedule />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/deleteprofile",
      element: (
        <>
          <PrivateRoute
            element={<DeleteProfile />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/changepassword",
      element: (
        <>
          <PrivateRoute
            element={<ChangePassword />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/alertjobs",
      element: (
        <>
          <PrivateRoute
            element={<AlertJobs />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/SearchJobs",
      element: (
        <>
          <PrivateRoute
            element={<Searchjobs />}
            isProtected={false}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/manageclass",
      element: (
        <>
          <PrivateRoute
            element={<ManageBatch />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Candidates",
      element: (
        <>
          <PrivateRoute
            element={<PeopleSearch />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/BlockCompanies",
      element: (
        <>
          <PrivateRoute
            element={<BlockCompanies />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/FollowedCompanies",
      element: (
        <>
          <PrivateRoute
            element={<FollowedCompanies />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Settings",
      element: (
        <>
          <PrivateRoute
            element={<Settings />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/Profile",
      element: (
        <>
          <PrivateRoute
            element={<InstituteProfile />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/ViewJobs",
      element: (
        <>
          <PrivateRoute
            element={<ViewJobs />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/ManageApplications",
      element: (
        <>
          <PrivateRoute
            element={<ApplicantJobs />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {
      path: "/AlertCandidates",
      element: (
        <>
          <PrivateRoute
            element={<AlertCandidates />}
            isProtected={true}
            redirectTo="/Home"
          />
        </>
      ),
    },
    {path:"*",
      element: <NotFound />
    }
  ]);

  return routes;
};

// Create Routing

const AppWrapper = () => {
  const [isDark, setIsDark] = useLocalStorage("isDark", false);
  useEffect(() => {
    document.body.style.backgroundColor = isDark ? "#000" : " #F5F5F5";
    document.body.style.color = isDark ? "#f9f7f7" : "#202020";
    const modalElement = document.querySelector(".modal-header"); // Replace with your modal class or ID
    console.log();
    if (modalElement) {
      modalElement.style.backgroundColor = isDark
        ? "#121212 !important"
        : "#ffffff !important";
    }
  }, [isDark]);

  useEffect(() => {
    let linkElement;

    if (isDark) {
      linkElement = document.querySelector(
        `link[href="https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/light.css"]`
      );
      if (linkElement) {
        document.head.removeChild(linkElement);
      }
      linkElement = document.createElement("link");
      linkElement.rel = "stylesheet";
      linkElement.href =
        "https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/dark.css";
      document.head.appendChild(linkElement);
    } else {
      linkElement = document.querySelector(
        `link[href="https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/dark.css"]`
      );
      if (linkElement) {
        document.head.removeChild(linkElement);
      }
      linkElement = document.createElement("link");
      linkElement.rel = "stylesheet";
      linkElement.href =
        "https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/light.css";
      document.head.appendChild(linkElement);
    }

    return () => {
      if (linkElement) {
        document.head.removeChild(linkElement);
      }
    };
  }, [isDark]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    document.body.setAttribute("data-theme", isDark ? "dark" : "light");
  }, [isDark]);
  return (
    <>
      {!loading ? (
        <div data-theme={isDark ? "dark" : "light"}>
          <Router>
            <ScrollToTop />
            <App setIsDark={setIsDark} />
          </Router>
        </div>
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default AppWrapper;
